import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import clickEvent from '@/app/components/search/Curiosity/clickEvent.ts';
import { RouteType } from '@/app/components/search/Curiosity';
import {
  BannerContainer,
  BannerContent,
  BannerCta,
  BannerCtaButton,
  BannerText,
  BannerTextDescription,
  BannerTextIcon,
  BannerTextTitle,
} from '@/app/components/search/components/Banners/MyPriceBanner/styled.ts';
import getSearchParams from '@/app/components/search/common/getSearchParams.ts';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { createMyPriceLoginBannerClickedPayload } from '@/app/common/starTrack/events/myPriceLoginBannerClicked.ts';
import { useTranslation } from '@/app/components/translations/Translation.tsx';

const MyPriceBanner = () => {
  const { commonData, localization, curiosityParams } = usePageWrapperData();
  const { starTrack } = useCommonClient();
  const { t } = useTranslation();
  const { imageBasePath } = localization;
  const icon = `${imageBasePath}icons/my_price_white.svg`;

  const handleConfirm = () => {
    const queryParams = getSearchParams();

    clickEvent({
      clickParams: {
        event_name: 'myprice_banner',
        event_context: 'banner_cta',
      },
      routeType: RouteType.OSMAP,
      commonData,
      localization,
      curiosityParams,
    });

    // TODO: add event to schema
    starTrack.myPriceLoginBannerClicked(createMyPriceLoginBannerClickedPayload({ searchParams: queryParams }));

    window.dispatchEvent(new CustomEvent('lmn:login:modal:open'));
  };

  return (
    <BannerContainer>
      <BannerContent>
        <BannerTextIcon>
          <img src={icon} alt="" />
        </BannerTextIcon>
        <BannerText>
          <BannerTextTitle>{t('vacation.oss.myprice.banner.title')}</BannerTextTitle>
          <BannerTextDescription>{t('vacation.oss.myprice.banner.desc')}</BannerTextDescription>
        </BannerText>
      </BannerContent>
      <BannerCta>
        <BannerCtaButton disabled={false} onClick={handleConfirm}>
          {t('vacation.oss.myprice.banner.primary')}
        </BannerCtaButton>
      </BannerCta>
    </BannerContainer>
  );
};

export default MyPriceBanner;
